/*
CAPITAL HOUSE THEME - COPYRIGHT NOTICE
Copyright (c) 2026 Capital House. All rights reserved.

This file is part of the Capital House Shopify theme. The Capital House
design, code, sections, snippets, styles and scripts are the intellectual
property of Capital House and are protected by copyright law.

This theme may only be used by customers and students who have purchased
it directly from Capital House, and only for their own Shopify store(s).

You may NOT, without prior written permission from Capital House:
  - share, send, give away or lend this theme or any part of it to others;
  - resell, redistribute or sublicense this theme;
  - publish this code, in whole or in part, online or offline;
  - copy or reuse any part of this code in your own or any other theme;
  - remove or alter this copyright notice.

Any unauthorized use, copying or distribution is strictly prohibited and
may result in loss of access and legal action.

For licensing questions, please contact Capital House.

Portions of this theme are based on "Dawn" by Shopify Inc.,
Copyright (c) 2021-present Shopify Inc., used under the MIT License.
*/
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
